


























































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { ExecType, BoolPresentStatus, UserWorkStatus } from "@/enum/tel.ts";
import { UserWorkStatusRangeEnum } from "@/enum/index";

@Component({
  name: "orderReview",
})
export default class orderReview extends Vue {
  @Provide() private searchForm: any = {
    ticketid: null, //Ticket ID
    planid: null, //借款 ID
  };
  @Prop() selectedTicketIds: any; //被选中的TicketId
  @Prop() itemid: any; //itemid
  @Prop() orderType: any; //orderType
  @Prop() ticketOrdertype: any; //orderType
  @Provide() private labelPosition: string = "right";
  @Provide() private userData: any = [];
  @Provide() private selectedAssignUser: any; //被选中的员工
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isLoanding: boolean = false;
  @Provide() private confirmLoanding: boolean = false; //点击确定

  @Provide() private name: string = "";
  @Provide() private email: string = "";
  @Provide() private UserGroup: string = "";
  // 角色
  @Provide() private roleData: any = [];
  // @Provide() private WorkStatus: UserWorkStatus = UserWorkStatus.USER_WORK_STATUS_UNSPECIFIED;// 工作状态,适用于电核系统 etc: 开始接单、停止接单
  @Provide() private WorkStatus:  number | null = null;// 工作状态,适用于电核系统 etc: 开始接单、停止接单
  @Provide() private ExecType: ExecType = ExecType.EXEC_TYPE_TEL_VERIFY;// 员工执行的业务类型, 不传默认为催收，电核请传递 EXEC_TYPE_TEL_VERIFY
  // @Provide() private IsAttendance: BoolPresentStatus = BoolPresentStatus.BOOL_UNSPECIFIED;// 是否出勤
  @Provide() private IsAttendance:  number | null = null;// 是否出勤
  // 工作状态筛选框列表
  @Provide() private IsAttendanceRangeEnum: any = Object.entries(BoolPresentStatus)
          .slice(0)
          .map((item: any, index: number) => {
            switch (index) {
              case 0:
                item[2] = "ticketLgy.All";
                break;
              case 1:
                item[2] = "v0707.Yes";
                break;
              case 2:
                item[2] = "v0707.No";
                break;
            }
            return item;
          });
  // 工作状态筛选框列表
  @Provide() private UserWorkStatusRangeEnum: any = Object.entries(UserWorkStatus)
          .slice(0)
          .map((item: any, index: number) => {
            switch (index) {
              case 0:
                item[2] = "ticketLgy.All";
                break;
              case 1:
                item[2] = "ticketFhb.continueAcceptTicket";
                break;
              case 2:
                item[2] = "ticketFhb.stopAcceptTicket";
                break;
            }
            return item;
          });

  private created() {
    this.selectList();
    this.getRoleList()
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    this.selectList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.selectList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.selectList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.selectList();
  }
  // 当前被选中
  private currentmes(val: any) {
    this.selectedAssignUser = val;
  }
  // 取消
  private hideMsk() {
    this.hideContainer();
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  // 点击确定
  private async confirm() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      ticketid: this.selectedTicketIds, //Ticket ID
      ordertype: this.itemid, //工单类型
      staffid: this.selectedAssignUser.id, // 员工ID
    };
    this.confirmLoanding = true;
    const { batchAssignTicketReq, batchAssignTicketRequest }: any = await import(
      "@/request/getVerifyOrderData"
    );
    let res = await batchAssignTicketRequest.handleHttp(batchAssignTicketReq(_arg), this);
    this.confirmLoanding = res ? res.loading : false;
    if (res && res.right) {
      this.$message({
        type: "success",
        message: "Success!",
      });
      this.hideContainer();
    }
  }
  private async getRoleList() {
    let _arg: any = {
      execType: this.ExecType,
    }
    const {
      setListUserGroupByTypeReq,
      getListUserGroupByTypeRequest
    }: any = await import("@/request/staffManagement");
    let res = await getListUserGroupByTypeRequest.handleHttp(
            setListUserGroupByTypeReq(_arg),
            null
    );
    if (res && res.right) {
      if (res.usergroupinfosList && res.usergroupinfosList.length > 0) {
        this.roleData = res.usergroupinfosList
      } else {
        this.roleData = [];
      }
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  // 获取人员列表
  private async selectList() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      name: this.name,
      email: this.email,
      // 用户组
      UserGroup: '' + this.UserGroup, //string UserGroup = 5;
    // 员工执行的业务类型, 不传默认为催收，电核请传递 EXEC_TYPE_TEL_VERIFY
      ExecType: +this.ExecType, //xcommon.ExecType ExecType = 6;
    // 是否出勤，默认出勤状态
      IsAttendance: 1, // xcommon.Bool IsAttendance = 7;
    // 工作状态,适用于电核系统 etc: 开始接单、停止接单
      WorkStatus: Number(this.WorkStatus), // xcommon.UserWorkStatus WorkStatus = 8;
    };
    this.isLoanding = true;
    const { searchUserReq, searchUserRequest }: any = await import(
      "@/request/getVerifyOrderData"
    );
    let res = await searchUserRequest.handleHttp(searchUserReq(_arg), this);
    this.isLoanding = res ? res.loading : false;
    if (res && res.right) {
      this.pagerCount = res.pageout.total;
      let _list: any = res.userinfosList;
      if(_list.length > 0) {
        // this.userData = res.userinfosList;
        const arr: any[] = [];
        _list.forEach((item: any) => {
          switch('' + (item as any).workstatus) {
            case '0':
              item.workstatusText = 'ticketLgy.All';
              break;
            case '1':
              item.workstatusText = "ticketFhb.continueAcceptTicket";
              break;
            case '2':
              item.workstatusText = "ticketFhb.stopAcceptTicket";
          }
          item.loadnum = "";
          arr.push(item.id);
        });
        this.getUserLoad(arr, _list)
      } else {
        _list = [];
        this.userData = [];
      }
    }
  }
  // 获取用户负载
  private async getUserLoad(arr: any[], tableList: any[]) {
    let _arg: any = {
      UseridsList: arr,
      Ticketitemid: this.orderType ? this.orderType : this.ticketOrdertype
    };
    // this.isLoanding = true;
    const { getUserLoadReq, getUserLoadRequest }: any = await import(
            "@/request/getVerifyOrderData"
            );
    let res = await getUserLoadRequest.handleHttp(getUserLoadReq(_arg), this);
    // this.isLoanding = res ? res.loading : false;
    if (res && res.right) {
      this.dwList(res.listList, tableList);
    } else {
      return null;
    }
  }
  // 处理列表数据
  private dwList(list: any, tableList: any){
    tableList.forEach((item: any, index: number ) =>{
      item.loadnum = list[index].loadnum ? list[index].loadnum: 0;
      return item;
    });
    this.userData = tableList;
  }
}
